import { UserOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';
import { appRoute } from 'app/railways/router/routes';

const appVersion = import.meta.env.VITE_APP_VERSION;

export const UserLoginData = observer(() => {
  const userProfileStore = useUserProfileStore();

  const id = userProfileStore.data.id;
  const login = userProfileStore.data.login;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      Версия: {appVersion}
      <Divider type="vertical" />
      <Link to={appRoute.PROFILE.path} style={{ color: '#000' }}>
        {login} (ID: {id})
      </Link>
      <Link to={appRoute.PROFILE.path} style={{ marginLeft: 8 }}>
        <UserOutlined style={{ fontSize: 17 }} />
      </Link>
    </div>
  );
});
